/**
 * Shared internal names used by the report builder frontend.
 */
export const ENTITY_PROFILE_DETAIL = "entity_profile_detail";
export const COMPLIANCE_SUMMARY = "compliance_summary";
export const ENTITY_STATUS_SUMMARY = "entity_status_summary";
export const QUESTION_RESPONSE_SUMMARY = "question_response_summary";
export const QUESTION_STATISTICS_SUMMARY = "question_statistics_summary";
